__turbopack_context__.v({
  "container": "styles-module__7pktmG__container",
  "ebayCampaignBanner": "styles-module__7pktmG__ebayCampaignBanner",
  "header": "styles-module__7pktmG__header",
  "heartbeat": "styles-module__7pktmG__heartbeat",
  "noResultsFallbackContainer": "styles-module__7pktmG__noResultsFallbackContainer",
  "noResultsFallbackTextContainer": "styles-module__7pktmG__noResultsFallbackTextContainer",
  "noResultsFallbackTitle": "styles-module__7pktmG__noResultsFallbackTitle",
  "productCardListItem": "styles-module__7pktmG__productCardListItem",
  "searchHeaderText": "styles-module__7pktmG__searchHeaderText",
  "searchHeaderTopContent": "styles-module__7pktmG__searchHeaderTopContent",
  "searchInput": "styles-module__7pktmG__searchInput",
  "searchQuerySecondary": "styles-module__7pktmG__searchQuerySecondary",
});
